import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  centered: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: "#f0f2f5",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 20,
    marginTop: 30,
    marginHorizontal: 16,
    maxWidth: 500,
    minWidth: 300,
    alignSelf: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  titulo: {
    marginBottom: 20,
    color: "#077A97",
    fontSize: 20,
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  picker: {
    marginBottom: 20,
  },
  noAssets: {
    alignItems: "center",
    marginVertical: 20,
  },
  button: {
    backgroundColor: "#077A97",
    paddingVertical: 14,
    borderRadius: 8,
    alignItems: "center",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
    fontSize: 16,
  },
  cardDescription: {
    fontSize: 14,
    color: "#6c757d",
    marginBottom: 20,
  },
});

export default styles;
